export const buildSubcategoryHref = (basePath, subcategory) =>
  `${basePath}?subcategory=${encodeURIComponent(subcategory)}`;

export const slugifySubcategory = subcategory =>
  subcategory.toLowerCase().replace(/\s+/g, '-');
